
import React, {useState} from "react";
//import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./Revision.css";
import ListaDocs from "../../../components/ListaDocs/ListaDocs";
import {  Divider, Button, Modal, Input, Form, message, Spin, Icon,Row, Col,  } from "antd";
import SelectDocumentos from "../../../components/ListaDocs/SelectDocs";
import axios from "axios";
import { Tooltip } from '@material-ui/core';
import { EyeOutlined, CheckOutlined, DownloadOutlined, FileExcelOutlined  } from "@ant-design/icons";
import Mensajes from "../../../components/Mensajes/Mensajes";
import { Redirect } from 'react-router';
import jwtDecode from "jwt-decode";
import GridFilters from "../../../utils/GridFilters";
import { descargaExcel } from "./ValidacionExcel"

//const { Option } = Select;
//const { Title } = Typography;
const { TextArea } = Input;

const urlConsultaDocumentos = `${localStorage.getItem('SERVERCENTRAL')}/consultaArticulosV`;
const urlTiposClasificacion = `${localStorage.getItem('SERVERCENTRAL')}/obtenTiposClasificacionEleccionV`;
//const urlCargaArchivoArticulo = `${basePath}/cargaArchivoArticulo`;
const urlDesactivaArticulo = `${localStorage.getItem('SERVERCENTRAL')}/desactivaArticuloV`;
const enviaNotificacion = `${localStorage.getItem('SERVERCENTRAL')}/enviaNotificacion`;
const urlDescargaZipR          = `${localStorage.getItem('SERVERCENTRAL')}/descargarZipR`;
let desactivoc = "";
let desactivom = "";
let desactivoe = "";
let desactivoi = "";
let desactivog = "";
const permisos = localStorage.getItem('ROL_USUARIO');
//const permisos="DOCSYMAT.CONSULTA.OPLE.JL";
var tiempoMensaje = 5;

let isRolConsulta = false;
let isRolCAU = false;

class ValidacionDocumentos extends React.Component {
  constructor(props) {
    super(props);
    
    const estadoSel = props.user.infoMenu.estadoSelec !== null ? props.user.infoMenu.estadoSelec.idEstado : props.user.infoMenu.detalleSelec.idEstado;
    const procesoSel = localStorage.getItem('ID_PROCESO_ELECTORAL');
    const detalleSel = localStorage.getItem('ID_DETALLE_PROCESO');

    let data = JSON.stringify({
      idProceso: procesoSel,
      idEstado: estadoSel,
      idDetalleProceso: detalleSel
    })
    this.handleClickConsultar = this.handleClickConsultar.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleModalEnviar = this.handleModalEnviar.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNotificar = this.handleNotificar.bind(this);
    this.handleClickDescargarZip=this.handleClickDescargarZip.bind(this)
    
    this.state = {
      consulta: false,
      seleccion: this.props === undefined || this.props.location.state === undefined || this.props.location.state.idTipoDocumentacion === null || this.props.location.state.idTipoDocumentacion === undefined ? -1 : this.props.location.state.idTipoDocumentacion,
      posts: [],
      idArticulo: -1,
      entidad: "",
      tipoClasificacion: "",
      nombreArticulo: "",
      modifica: -1,
      captura: -1,
      desactiva: -1,
      idEstadoSeleccionado: estadoSel,
      idProcesoSeleccionado: procesoSel,
      idDetalleProcesoSeleccionado: detalleSel,
      disableNotificacion: false,
      disableModificar: false,
      disableCapturar: false,
      modalVisible: false,
      modalLoading: false,
      redirect: false,
      dataSelect: data,
      visibleAlert: {
        activado: false,
        tipoMensaje: "",
        mensaje: "",
      },
      urli: ""
    };

    if( this.props !== undefined && this.props.location.state !== undefined && this.props.location.state.idTipoDocumentacion !== null && this.props.location.state.idTipoDocumentacion !== undefined ){
      this.handleSelect(this.props.location.state.idTipoDocumentacion);
    }
  }



  componentDidMount() {
    /*  if(this.state.disableNotificacion !==null)
      {
        if(this.state.disableNotificacion === true && this.state.disableModificar === true && this.state.disableCapturar === false)
        desactivoc = true;
        desactivom = true;
        desactivoe = true;
        desactivoi = true;
        desactivog = true;
      } */
    //console.log("Permisos generales estoy cargando la aplicación", permisos, desactivoc, desactivom, desactivoe, desactivoi, desactivog);
    //console.log("Estado", this.state.idEstadoSeleccionado);
    if (!this.props.isReporte && (this.state.idEstadoSeleccionado === null || this.state.idEstadoSeleccionado === 0)) {
       message.warning("Favor de seleccionar una entidad en el menú del proceso electoral.", tiempoMensaje);
    }

    if (permisos === ("DOCSYMAT.ADMIN.OC" || "DOCSYMAT.CAPTURA.OC" || "DOCSYMAT.CAPTURA.JL" || "DOCSYMAT.SUPERVISOR.OC" || "DOCSYMAT.REVISOR.OC")) {
      desactivoc = false;
      desactivom = false;
      desactivoe = false;
      desactivoi = false;
      desactivog = false;
      //console.log("Permisosgenerales", permisos, desactivoc, desactivom, desactivoe, desactivoi, desactivog);
    }

    else if (permisos === ("DOCSYMAT.CONSULTA.OC" || "DOCSYMAT.CONSULTA.JL" || "DOCSYMAT.CONSULTA.UTVOPL.OC")) {
      desactivoc = false;
      desactivom = true;
      desactivoe = true;
      desactivoi = true;
      desactivog = true;
      // console.log("Permisos consulta", permisos, desactivoc, desactivom, desactivoe, desactivoi, desactivog);
    }
    else if (permisos === "DOCSYMAT.CAU.OC") {
      desactivoc = false;
      desactivom = false;
      desactivoe = true;
      desactivoi = true;
      desactivog = true;
      //console.log("Permisos GENERALES NO GUARDAR", permisos, desactivoc, desactivom, desactivoe, desactivoi, desactivog);
      //tomar en cuenta que en los guardar de las acciones no es valido
    }
    else if (permisos === ("DOCSYMAT.CONSULTA.OPLE.JL" || "DOCSYMAT.CAPTURA.OPLE.JL")) {
      desactivoc = true;
      desactivom = true;
      desactivoe = true;
      desactivoi = true;
      desactivog = true;
      //console.log("Permisos NO TIENE", permisos, desactivoc, desactivom, desactivoe, desactivoi, desactivog);


    }

    isRolConsulta = ((permisos === "DOCSYMAT.CONSULTA.OC") ||
      (permisos === "DOCSYMAT.CONSULTA.JL") ||
      (permisos === "DOCSYMAT.CONSULTA.UTVOPL.OC")) ? true : false;
    isRolCAU = permisos === 'DOCSYMAT.CAU.OC' ? true : false;

  }


  handleSelect(values) {
    const value = values[0]
    this.setState(
      {
        posts: [],
        consulta: false,
        seleccion: value,
        nombreClasificacion: values[1]
      });
    let data = JSON.stringify({
      consultaParametros: {
        idProceso: this.state.idProcesoSeleccionado,
        idEstado: this.state.idEstadoSeleccionado,
        idDetalleProceso: this.state.idDetalleProcesoSeleccionado
      },
      tipoClasificacionEleccion: value,
    });
    console.log("DATOS CARGA ARTICULOS", data)
    const currentToken = localStorage.getItem('accessToken');
    axios
      .post(
        urlConsultaDocumentos, data,
        {
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json',
            Accept: "application/json",
            //"Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(response => {
        if (response.data.entity.code === 200) {
          this.setState({
            disableNotificacion: response.data.entity.notificacionDisable,
            disableModificar: response.data.entity.enableModificar,
            disableCapturar: response.data.entity.enableCaptura,
            posts: response.data.entity.articulos,
            modalVisible: false,
            seleccion: value,
            consulta: true,
            modalLoading: false,
            nombreClasificacion: values[1]
          });
        }
        else if (response.data.entity.code === 403) {
          localStorage.clear();
          window.location = "/login"
        }
      })
      .catch(function (error) {
        this.setState({ modalVisible: false, seleccion: value, consulta: false, modalLoading: false });
      });
  }

  handleClickConsultar(id, nombre, conAlerta) {
    //console.log("Handle consultar");
    this.setState({
      redirect: true,
      idArticulo: id,
      nombreArticulo: nombre,
      urli: "/revision/validacionconsulta"
    });
  }

  handleClickCargar(id, nombre, conAlerta) {
    //console.log("Handle cargar");
    this.setState({
      redirect: true,
      idArticulo: id,
      nombreArticulo: nombre,
      urli: "/revision/validacionobservaciones"
    });

  }

  handleClickModificar(id, nombre, conAlerta) {
    //console.log("Handle modificar");
    this.setState({
      redirect: true,
      idArticulo: id,
      nombreArticulo: nombre,
      urli: "/revision/validacionobservaciones"
    });
  }

  handleClickEliminar(id, conAlerta) {
    //console.log("Handle elimnar");
    this.setState({ modalVisible: true, idArticulo: id });
  }

  handleModalCancel() {
    //console.log("Handle buttom cancel");
    this.handleSelect(this.state.seleccion);
  }

  handleModalEnviar() {
    //console.log("Handle buttom enviar");
    this.setState({ modalLoading: true });
    const currentToken = localStorage.getItem('accessToken');
    let comentario = this.refs.comentarioArea.state.value;
    //console.log("comentario", comentario);
    let data = JSON.stringify({
      parametros: {
        idProceso: this.state.idProcesoSeleccionado,
        idEstado: this.state.idEstadoSeleccionado,
        idDetalleProceso: this.state.idDetalleProcesoSeleccionado
      },
      idTipoDocumentacion: this.state.seleccion,
      idArticulo: this.state.idArticulo,
      justificacion: comentario
    });
    axios
      .post(
        urlDesactivaArticulo, data,
        {
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json',
            Accept: "application/json",
            //"Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(response => {
        this.refs.comentarioArea.state.value = "";
        if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
          /* this.setState(
            {
              visibleAlert: {
                activado: true,
                tipoMensaje: "error",
                mensaje: response.data.entity.causa
              }
            }); */
          message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
        }
        else if (response.data.entity.code === 200) {
          if (response.data.entity.message !== null && response.data.entity.message !== "") {
            /* this.setState(
              {
                visibleAlert: {
                  activado: true,
                  tipoMensaje: "warning",
                  mensaje: response.data.entity.message
                }
              }); */
            message.warning(response.data.entity.message, tiempoMensaje);
          }
          else {
            /* this.setState(
              {
                visibleAlert: {
                  activado: true,
                  tipoMensaje: "success",
                  mensaje: "El artículo se ha desactivado correctamente."
                }
              }); */
            message.success("El artículo se ha desactivado correctamente.", tiempoMensaje);
          }
        }
        else {
          localStorage.clear();
          // console.log("Borro el local storage");
          window.location = "/login"
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
    this.handleSelect(this.state.seleccion);
  }

  handleClose() {
    this.setState({
      visibleAlert: {
        activado: false,
        tipoMensaje: "",
        mensaje: ""
      }
    });
  }


  handleNotificar() {
    //console.log("VALOR MODIFICA", this.state.disableModificar);
    //console.log("VALOR CAPTURA", this.state.disableCapturar);

    if (this.state.disableModificar === null)
      this.state.modifica = 3;
    this.state.captura = 1;
    if (this.state.disableCapturar === true)
      this.state.captura = 1;
    else if (this.state.disableCapturar === false)
      this.state.captura = 2;
    if (this.state.disableModificar === true)
      this.state.modifica = 2;
    else if (this.state.disableModificar === false)
      this.state.modifica = 1;
    if (this.state.disableModificar === null && this.state.disableCapturar === null) {
      this.state.modifica = 3;
      this.state.captura = 3;
    }

    //console.log("VALOR MODIFICA N", this.state.modifica);
    //console.log("VALOR CAPTURA N", this.state.captura);
    //console.log("Handle buttom notificar");
    const currentToken = localStorage.getItem('accessToken');
    const anio = localStorage.getItem('ANIO');
    const tipoProceso = localStorage.getItem('TIPO_PROCESO');
    const rol = localStorage.getItem('VERSION_USUARIO');
    const usuario = jwtDecode(localStorage.getItem('accessToken'));
    let data = JSON.stringify({
      parametros: {
        idProceso: this.state.idProcesoSeleccionado,
        idEstado: this.state.idEstadoSeleccionado,
        idDetalleProceso: this.state.idDetalleProcesoSeleccionado,
        anioProceso: anio,
        tipoProceso: tipoProceso,
        rol: rol,
        usuario: usuario.sub
      },
      idTipoDocumentacion: parseInt(this.state.seleccion),
      modifica: this.state.modifica,
      captura: this.state.captura
      // modifica: this.state.disableModificar,
      //captura: this.state.disableCapturar
      //areaResponsable: 1,
      //tipoPlantillaCorreo: 1
    });
    //console.log("Datos Notificacion", data);
    axios
      .post(
        enviaNotificacion, data,
        {
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json',
            Accept: "application/json",
            //"Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(response => {
        this.handleSelect(this.state.seleccion);
        if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
          //console.log("Error al mandar la notificacion")
          /* this.setState(
            {
              visibleAlert: {
                activado: true,
                tipoMensaje: "error",
                mensaje: response.data.entity.causa,
                
              }
            }); */
          message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
        }
        else if (response.data.entity.code === 200) {
          if (response.data.entity.message !== null && response.data.entity.message !== "") {
            //console.log("se mando la notificacion")
            /* this.setState(
              {
                visibleAlert: {
                  activado: true,
                  tipoMensaje: "warning",
                  mensaje: response.data.entity.message
                }
              }); */
            message.warning(response.data.entity.message, tiempoMensaje);
          }
          else {
            //console.log("Se mando la notificacion 1")
            /* this.setState(
              {
                visibleAlert: {
                  activado: true,
                  tipoMensaje: "success",
                  mensaje: "Se ha enviado la notificación al área correspondiente."
                }
              }); */
            message.success("Se ha enviado la notificación al área correspondiente.", tiempoMensaje);
          }
        }
        else {
          localStorage.clear();
          // console.log("Borro el local storage");
          window.location = "/login"
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
    this.handleSelect(this.state.seleccion);
  }

  onFinish(values) {
    //console.log("Success:", values);
  };

  onFinishFailed(errorInfo) {
    //console.log("Failed:", errorInfo);
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      //const urli='/revision/cargasesp';
      //console.log("NOMBRE ARTICULO", this.state.nombreArticulo);
      return <Redirect to={{
        pathname: this.state.urli,
        state: {
          idTipoDocumentacion: this.state.seleccion,
          idArticulo: this.state.idArticulo,
          nombreArticulo: this.state.nombreArticulo
        }
      }} />
    }
  }
  
   handleClickDescargarZip() {

    // Se obtiene el token
    const currentToken = localStorage.getItem('accessToken');
    let tipoProceso="Ord"
    let idEstado 
     if(this.props.user.infoMenu.detalleSelec.tipoProceso==="O")
     tipoProceso="Ord"
    else if(this.props.user.infoMenu.detalleSelec.tipoProceso==="E")
    tipoProceso="Ext"
    else if(this.props.user.infoMenu.detalleSelec.tipoProceso==="I")
    tipoProceso="Int"
    
    if (localStorage.getItem('ID_ESTADO_SELECCIONADO') > 0 || localStorage.getItem('ID_ESTADO_SELECCIONADO') !== 'null')     
      idEstado=localStorage.getItem('ID_ESTADO_SELECCIONADO');

      
      
    // Se construye el json
      let datos = JSON.stringify({
  
        nivelZip: "1",
      anio:localStorage.getItem('ANIO'),
      idEstado:idEstado,
      tipoProceso:tipoProceso,
      tipoDocumentacion:parseInt(this.state.seleccion),
	    proceso: localStorage.getItem('ID_PROCESO_ELECTORAL'),
      detalleProceso: localStorage.getItem('ID_DETALLE_PROCESO')
      
    });
     //let url=rev.idEstado>0 ||(localStorage.getItem('ID_ESTADO_SELECCIONADO') > 0 && homeData.etapaActual===1) ?urlDescargaZipR:urlDescargaZip
    // Se construye la promesa
    axios.post(
      urlDescargaZipR , // url del servicio
      datos, // json 
      {
        responseType: 'blob', // Tipo de respuesta esperada, es importante la ubicacion donde se coloca
        headers: {
          'Authorization': currentToken,
          'Content-Type': 'application/json',
        }
      }      
    ).then(({ data }) => {


    //  let aux = data.replace(/</g,"").replace(/>/g,"").replace(/&/g,"").replace(/'/g,"").replace(/"/g,"");
    //  console.log("archivo zip", aux)
    console.log("archivo zip", data)
     if(data !== 'null' || data !==''){
        // Se descarga el archivo zip
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'Documentos_Ultima_Revision.zip');       
        link.click();
        link.remove();
      }
      else if(data === 'null' || data==='')
      message.error("Error al descargar el archivo zip",tiempoMensaje);
    }
    ).catch(error => {
        //console.error("Error al descargar el archivo zip", error);
        message.error("Error al descargar el archivo zip",tiempoMensaje);
    });
}


  render() {
    //console.log("-----------------------------------------Se dibuja el componente");
    const eventHandlers = [{ "cargar": this.handleClickCargar }, { "consultar": this.handleClickConsultar }, { "modificar": this.handleClickModificar }, { "eliminar": this.handleClickEliminar }];
    //Se definen las columnas de la tabla de Listado de cargas
    //const { fileList } = this.state;
    const columns = [
      {
        Header: "No.",
        accessor: "consecutivo",
        sortable: false,
        filterable: false,
        style: {
          textAlign: "center"
        },
        width: 50,
        maxWidth: 50,
        minWidth: 50
      },
      ...(this.props.isReporte && (this.state.idEstadoSeleccionado === null || this.state.idEstadoSeleccionado === 0)
      ? [
          {
            Header: "Entidad",
            accessor: "entidad",
            ...GridFilters
          }
        ]
      : []),
      ...(this.props.isReporte
        ? [
            {
              Header: "Tipo de clasificación",
              accessor: "tipoClasificacion",
              ...GridFilters
            },
          ]
        : []),
      {
        Header: "Documento/Material",
        accessor: "nombre",
        ...GridFilters
      },
      {
        Header: "Tipo de Eleccion",
        accessor: "nombreTipoEleccion",
        ...GridFilters
      },
      {
        Header: "Observaciones",
        accessor: "conObservaciones",
        style: {
          textAlign: "center"
        },
        width: 200,
        maxWidth: 200,
        minWidth: 100,
        ...GridFilters
      },
      {
        Header: "Emblema",
        accessor: "conEmblema",
        style: {
          textAlign: "center"
        },
        width: 100,
        maxWidth: 100,
        minWidth: 100,
        ...GridFilters
      },
      {
        Header: "Estatus notificación",
        accessor: "estatusNotif",
        style: {
          textAlign: "center"
        },
        width: 200,
        maxWidth: 200,
        minWidth: 100,
        ...GridFilters
      },
      // Condicional para excluir la columna de "Acciones"
      ...(this.props.isReporte
        ? []
        : [
            {
              Header: "Acciones",
              width: 150,
              maxWidth: 150,
              minWidth: 150,
              Cell: props => (
                <div id="centrar">
                  {props.original.acciones.map((value, index) => {
                    if (value.nombre === "consultar") {
                      return [
                        <Tooltip title="Consultar" key={`consultar-${index}`}>
                          <Button
                            id="ilist"
                            type="link"
                            shape="circle"
                            onClick={this.handleClickConsultar.bind(
                              this,
                              props.original.id,
                              props.original.nombre,
                              value.conAlerta
                            )}
                            disabled={desactivoc}
                          >
                            <EyeOutlined />
                          </Button>
                        </Tooltip>,
                        <Divider id="dcolor" type="vertical" key={`divider-${index}`} />
                      ];
                    } else if (value.nombre === "cargar") {
                      return [
                        <Tooltip title="Validar" key={`validar-${index}`}>
                          <Button
                            id="ilist"
                            type="primary"
                            shape="circle"
                            onClick={this.handleClickCargar.bind(
                              this,
                              props.original.id,
                              props.original.nombre,
                              value.conAlerta
                            )}
                            disabled={desactivoi || isRolConsulta}
                          >
                            <CheckOutlined />
                          </Button>
                        </Tooltip>,
                        <Divider id="dcolor" type="vertical" key={`divider-${index}`} />
                      ];
                    } else if (value.nombre === "modificar") {
                      return [
                        <Tooltip title="Modificar" key={`modificar-${index}`}>
                          <Button
                            id="ilist"
                            type="link"
                            shape="circle"
                            onClick={this.handleClickModificar.bind(
                              this,
                              props.original.id,
                              props.original.nombre,
                              value.conAlerta
                            )}
                            disabled={desactivom || isRolConsulta}
                          >
                            <CheckOutlined />
                          </Button>
                        </Tooltip>,
                        <Divider id="dcolor" type="vertical" key={`divider-${index}`} />
                      ];
                    } else {
                      return <span key={`empty-${index}`} />;
                    }
                  })}
                </div>
              ),
              style: {
                color: "blue"
              },
              sortable: false,
              filterable: false
            }
          ])
    ];
    

    const downloadExcel = () =>{
      descargaExcel('HOJA 1', "reporte_notificacion", this.state.nombreClasificacion, this.state.posts, this.props.isReporte)
    }
    //console.log("POST", this.state.posts)
    return (
      //console.log("En el return"),
      <div>
        {this.renderRedirect()}
        {this.state.visibleAlert.activado ?
          (
            <Mensajes tipoMensaje={this.state.visibleAlert.tipoMensaje} mensaje={this.state.visibleAlert.mensaje} handleClose={this.handleClose} />
          ) : null}
        {(permisos === "DOCSYMAT.CAPTURA.JL" || permisos === "DOCSYMAT.CONSULTA.JL") ?
          <h1 id="titulo">{this.props.isReporte ? "Estatus de notificación" : "Revisión de documentos y materiales"}</h1> :
          (permisos === "DOCSYMAT.ADMIN.OC" || permisos === "DOCSYMAT.CAPTURA.OC" ||
            permisos === "DOCSYMAT.CONSULTA.OC" || permisos === "DOCSYMAT.SUPERVISOR.OC" || permisos === "DOCSYMAT.REVISOR.OC") ?
            <h1 id="titulo">
          {this.props.isReporte ? "Estatus de notificación" : "Validación de documentos y materiales"}</h1> 
          : <h1 id="titulo">{this.props.isReporte ? "Estatus de notificación" : "Validación de documentos y materiales"}</h1>}
         
         
        <Row>
          <Col span={10}>  
            <p id="msg">
              <span id="smsg">*</span>Tipo de clasificación de elección
            </p>
            <SelectDocumentos
              onChange={this.handleSelect}
              data={this.state.dataSelect}
              rutaWS={urlTiposClasificacion}
              seleccion={this.state.seleccion}
              isReporte={this.props.isReporte} 
            />
          </Col>
          {!this.props.isReporte && this.state.consulta && (
           <Col span={12}>
              <p id="msg">
                <Icon 
                  type="info-circle" 
                  theme="filled" 
                  className="icono-info" 
                />
                Descarga aquí todos los documentos de la última revision
              </p>
              <span style={{ paddingLeft: '20px' }}/>
                <Button 
                  className="boton-descargar-home" 
                  onClick={this.handleClickDescargarZip}
                  disabled = {this.state.posts.length === 0}
                >
                  <DownloadOutlined /> Descargar 
                </Button>
                <label className="texto-16-admin"><span style={{ paddingLeft: '10px' }} />
                  En formato .zip
                </label>
            </Col>
         )}
        </Row>
        <br/>  
        {!this.props.isReporte && (
          <h3>Listado de documentos y materiales a validar</h3>
        )}
        <div>
          {!this.state.consulta &&
            <div className="div_cargando">
              <br />
              {this.state.seleccion !== -1 ? (<Spin size="large" />) : null}
            </div>}
        </div>
        <div>
          {
          console.log(this.state.posts)
          }
          {this.state.consulta ? <ListaDocs eventos={eventHandlers} datos={this.state.posts} columnas={columns} filterable={true} /> : null}
        </div>

              <p id="contb">
                {this.state.consulta ? (
                  <>
                    {}
                    {this.props.isReporte ? (
                      // Botón para reportes (Descargar)
                      <Button
                        id="descargar"
                        disabled={this.state.posts.length === 0}
                        onClick={() => {
                          downloadExcel();
                        }}
                        className="boton-descargar-home"
                      >
                        <DownloadOutlined /> Descargar
                      </Button>
                    ) : (
                      // Botón para el módulo (Excel)
                      <Button
                        id="btonc"
                        disabled={this.state.posts.length === 0}
                        onClick={() => {
                          downloadExcel();
                        }}
                      >
                        <FileExcelOutlined /> Excel
                      </Button>
                    )}
                    &nbsp;
                    {}
                    {!this.props.isReporte && (
                      <Button
                        id="btonc"
                        disabled={
                          this.state.disableNotificacion ||
                          isRolCAU ||
                          isRolConsulta ||
                          this.state.posts.length === 0
                        }
                        onClick={this.handleNotificar}
                      >
                        Notificar
                      </Button>
                    )}
                  </>
                ) : null}
              </p>


        <Modal
          visible={this.state.modalVisible}
          title="Confirmación para desactivar el Documento/Material seleccionado"
          okButtonProps={{ disabled: isRolCAU }}
          onOk={this.handleModalEnviar}
          onCancel={this.handleModalCancel}
          footer={[
            <div>
              <Form.Item>
                <Button key="submit" disabled={isRolCAU} type="primary" loading={this.state.modalLoading} onClick={this.handleModalEnviar}>
                  Enviar
                  </Button>
              </Form.Item>,
                      <Button key="back" onClick={this.handleModalCancel}>
                Cancelar
                    </Button>,
              </div>
          ]}
        >
          <Form
            name="basic"
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >

            <p>Está seguro que desea desactivar este artículo, en caso de confirmar capture la justificación.</p>
            <Form.Item
              label="Comentario"
              name="Comentario"
              rules={[{ required: true, message: 'Por favor ingresa la justificación!' }]}
            >
              <TextArea ref="comentarioArea" rows={6} autoSize={false} allowClear={true} />
            </Form.Item>
          </Form>
        </Modal>
      </div >
    );
  }
}
export default ValidacionDocumentos;